function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons2 = function SvgSurveyIcons2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SurveyIcons-2_svg__a",
    width: 31.79,
    height: 36.92,
    x: 6.67,
    y: 4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67 4h31.79v36.92H6.67V4z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 38.87v-7.19a2.05 2.05 0 0 1 4.1 0v7.19a2.05 2.05 0 0 1-4.1 0Z",
    style: {
      fill: "#f05d22",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SurveyIcons-2_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 20a1 1 0 0 1 0-1.31.89.89 0 0 1 .64-.28h2.83A10.77 10.77 0 1 1 23 29.44a10.71 10.71 0 0 1-7.48-3.19L17.83 24a7.51 7.51 0 0 0 10.74 0 7.76 7.76 0 0 0 0-10.88 7.51 7.51 0 0 0-10.74 0 7.71 7.71 0 0 0-2.22 5.29h3a.93.93 0 0 1 .61 1.59l-4.49 4.55a.92.92 0 0 1-1.29 0Zm3.23 13.7h24.23a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H12.23a5.6 5.6 0 0 0-5.56 5.63v25.65a5.6 5.6 0 0 0 5.56 5.63h24.23a2 2 0 0 0 0-4H12.23a1.59 1.59 0 0 1 0-3.17Z",
    style: {
      fill: "#4d6a80"
    }
  })));
};
export default SvgSurveyIcons2;